import { ViewportSyncMode } from "@/shared/state/visualization/schema";

/**
 * The sync mode a panel operates under when the user has not chosen one: the x
 * axis follows other panels, the y axis does not.
 */
export const DEFAULT_VIEWPORT_SYNC_MODE: ViewportSyncMode = "x";

/**
 * The sync mode the panel operates under: the persisted setting, defaulting to `"x"`, except
 * while the panel's x axis is aligned, when it is `""` (sync nothing).
 *
 * A shared viewport is a fraction of each panel's own x extents (`PlotRenderer.applyViewport`),
 * and an aligned panel measures x as elapsed time from each series' own basis rather than
 * absolute time, so the same fraction picks out a different window in an aligned panel than in
 * the panel that broadcast it. An aligned panel therefore neither broadcasts its viewport nor
 * applies viewports broadcast by other panels. The persisted setting is left alone, so sync
 * resumes with the user's chosen mode when the panel goes back to plotting absolute time.
 */
export function effectiveViewportSyncMode(
  persistedMode: ViewportSyncMode | undefined,
  isAligned: boolean,
): ViewportSyncMode {
  if (isAligned) {
    return "";
  }
  return persistedMode ?? DEFAULT_VIEWPORT_SYNC_MODE;
}
